var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyWaterDisposalCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grey_water_disposal_-_Coral"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 41.341,
    cy: 74.77,
    r: 8.22
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 89.008,
    cy: 74.77,
    r: 8.22
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 49.561,
    y1: 74.77,
    x2: 80.788,
    y2: 74.77
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M97.051,74.903h9.161 c3.321,0,6.013-2.692,6.013-6.013v-8.732c0-0.587-0.172-1.16-0.494-1.651L94.46,32.213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.122,74.77h-7.775 c-3.321,0-6.013-2.692-6.013-6.013V24.836c0-3.321,2.692-6.013,6.013-6.013h76.298c1.147,0,2.195,0.653,2.7,1.684l4.611,9.409 c0.489,0.999-0.238,2.165-1.35,2.165H85.446c-1.66,0-3.006,1.346-3.006,3.006V48.43c0,1.66,1.346,3.006,3.006,3.006h21.165"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.122,38.094v7.861 c0,3.321,2.692,6.013,6.013,6.013h23.505c3.321,0,6.013-2.692,6.013-6.013v-7.861c0-3.321-2.692-6.013-6.013-6.013H39.135 C35.814,32.081,33.122,34.773,33.122,38.094z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M129.559,85.165"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M2.128,85.165h51.915v7.75H24.627 c-1.566,0-2.835,1.269-2.835,2.835v12.831c0,1.566,1.269,2.835,2.835,2.835H65.78"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M86.932,92.915"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M77.517,92.915"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 65.78,
    y1: 82.99,
    x2: 65.78,
    y2: 95.343
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F18C7E"
    },
    points: "58.998,87.375 65.78,94.161 72.561,87.375 72.561,93.133 65.78,99.915 58.998,93.133  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M129.432,85.165H77.767v23.415 c0,1.566-1.269,2.835-2.835,2.835H65.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18C7E"
    },
    d: "M91.752,100.901l1.806,7.831l0.393,2.18l0.395-2.135l1.545-7.876h3.015l1.625,7.83l0.416,2.181 l0.423-2.096l1.822-7.915h2.909l-3.847,13.675h-2.736l-1.651-7.997l-0.482-2.644l-0.482,2.644l-1.651,7.997h-2.653l-3.878-13.675 H91.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18C7E"
    },
    d: "M110.082,102.33c1.101-1.126,2.502-1.688,4.203-1.688c2.276,0,3.94,0.755,4.993,2.264 c0.581,0.848,0.894,1.698,0.937,2.552h-2.857c-0.183-0.656-0.416-1.15-0.7-1.484c-0.509-0.594-1.264-0.891-2.263-0.891 c-1.019,0-1.821,0.419-2.409,1.257s-0.882,2.023-0.882,3.558s0.311,2.683,0.931,3.446c0.62,0.765,1.408,1.146,2.364,1.146 c0.979,0,1.728-0.327,2.241-0.982c0.284-0.354,0.521-0.882,0.708-1.587h2.839c-0.245,1.49-0.87,2.703-1.877,3.637 s-2.296,1.401-3.868,1.401c-1.946,0-3.476-0.631-4.59-1.893c-1.113-1.269-1.67-3.006-1.67-5.215 C108.182,105.462,108.816,103.623,110.082,102.33z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    cx: 104.747,
    cy: 107.158,
    r: 17.538
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 116.236,
    y1: 93.915,
    x2: 93.46,
    y2: 120.578
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyWaterDisposalCoral);
export default __webpack_public_path__ + "static/media/Grey Water Disposal - Coral.5c6aa4bee5d8793142b04f2f59723477.svg";
export { ForwardRef as ReactComponent };